import MultiSelect from './MultiSelect.vue';
import Option from './Option.vue';
import OptionGroup from './OptionGroup.vue';
import PopulatedSelect from './PopulatedSelect.vue';
import Select from './Select.vue';
import VirtualSelect from './VirtualSelect.ts.vue';

export default [
  Option,
  OptionGroup,
  PopulatedSelect,
  Select,
  MultiSelect,
  VirtualSelect,
];
